import {
    urlEncodedParams,
    getRedirectURL,
    getOauthClientID,
    getStore,
} from "../../factory";

/* this is google */
import { googleOauthSettings } from "../../../api/endpoints";
 
function getClientID (p) {
    return `${getOauthClientID(googleOauthSettings,p)}.${googleOauthSettings.APPS_URL}`;
}

// const SCOPE = 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/calendar';
const SCOPE ='https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fcalendar';
 
// https://staging-oauth.ecal.com/auth/google/oauth2callback

function generateParams (params) {
    return {
        response_type: 'code',
        redirect_uri: `https://${getRedirectURL()}/auth/google/oauth2callback`,
        client_id: getClientID(params),
        access_type: 'offline',
        approval_prompt: 'auto',
        include_granted_scopes: 'true',
        login_hint: '',
        scope: SCOPE,
        state: {
            locale: params.locale,
            apiKey: params.apiKey,
            sessionId: params.oauthSessionId,
            browser: params.browser,
            calendarApp: params.calendar,
        },
    };
}

function googleOAuthAPI (params) {
    const appStore = getStore('appStore');
    const flags = appStore.flags;
    const p = generateParams(params);
    let url = `${googleOauthSettings.OAUTH_URL}${urlEncodedParams(p)}`;

    if (!flags.inAppBrowser) {
        window.open(url, '_self');
    } else {
        const appClient = getStore('appClientStore');
        appClient.locationAssign(url);
    }
}

export default googleOAuthAPI;
